import { useWorkspaceLoadingSignal } from './WorkspaceReadinessContext';

/** The subset of an RTK Query hook result the gate cares about. */
export type ColdLoadable = { isFetching: boolean; currentData?: unknown };

/**
 * First load for the CURRENT argument. RTK's `isLoading` stays false after a
 * project switch (it keeps the previous argument's `data`), and `isFetching`
 * alone would hold during every SSE-driven invalidation; `currentData` is
 * undefined exactly while nothing for this argument is on screen yet.
 */
export const isColdLoading = (query: ColdLoadable): boolean => (
  query.isFetching && query.currentData === undefined
);

/** Hold the workspace loading shell while an RTK query is cold-loading. */
export const useRtkLoadingSignal = (key: string, query: ColdLoadable): void => {
  useWorkspaceLoadingSignal(key, isColdLoading(query));
};
